/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';

const useIdleTimer = (
  timeout: number,
  token: string | null,
  onTimeout: () => void
) => {
  const [isIdle, setIsIdle] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastInteraction = useRef<number>(Date.now());
  
  const resetTimer = () => {
    lastInteraction.current = Date.now();
    setIsIdle(false);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      const timeSinceLastInteraction = Date.now() - lastInteraction.current;

      if (timeSinceLastInteraction >= timeout) {
        setIsIdle(true);
        onTimeout();
      }
    }, timeout);
  };

  useEffect(() => {
    if (!token) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      return;
    }

    resetTimer();
    const events = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
    ];

    const handlerEvent = () => resetTimer();
    events.forEach((event) => {
      window.addEventListener(event, handlerEvent);
    });

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handlerEvent)
      );
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [timeout, token, onTimeout]);

  return isIdle;
};

export default useIdleTimer;
